import { createContext } from "react";
import { TokenProps } from "../models/theme";

export interface TokenContextInterface {
  token: TokenProps | null;
  updateToken: (data: TokenProps) => void;
}

export const tokenContextDefaults: TokenContextInterface = {
  token: null,
  updateToken: () => {
    //function to clear Data
  },
};

export const AuthContext =
  createContext<TokenContextInterface>(tokenContextDefaults);
